// Models
import { TaskKind } from "../client/planner/task/ITask";
/**
 * Returns whether a task can use the plan-scoped task history API.
 */ export function getIsTaskHistorySupportedForTask(task) {
    return task != null && task.kind !== TaskKind.ToDo;
}
